import { getLanguage } from '../../../services/api.js'

export default {
  state: {
    lng: null,
  },
  mutations: {
    lng(state, lng) {
      state.lng = lng
    },
  },
  actions: {
    getLanguage(context, params) {
      getLanguage(params).then(res => {
        context.commit('lng', res)
      })
    },
  },
}
